import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllVehicleColors = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/vehicle-colors',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveVehicleColor = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/vehicle-colors',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateVehicleColor = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/vehicle-colors/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteVehicleColor = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/vehicle-colors/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllVehicleColors,
  saveVehicleColor,
  deleteVehicleColor,
  updateVehicleColor,
}
